import API from "components/Apis/API"
import { toast } from 'react-toastify';

export const defaultDensity = () => {
    return {
        DateList: [],
        BusDensity: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
        OrderDensity: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
    };
};

export const fetchDensity = async (selected) => {
    const url = "admin/get_density_history";
    let formData = new FormData();
    formData.append("period", selected.period);
    formData.append("end_date", selected.date);

    let data = {};
    try {
        const response = await API.postData(url, formData);
        if (!response.status) {
            throw ("Non response density")
        }
        data = {
            DateList: response.data.DateList,
            BusDensity: response.data.BusDensity,
            OrderDensity: response.data.OrderDensity,
        };
    }
    catch {
        data = defaultDensity()
        toast.error("Invalid selection made");
    }

    return data
};

export const defaultUtilization = () => {
    return {
        DateList: [],
        WeightWaste: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
        LengthWaste: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
        WeightUtilization: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
        LengthUtilization: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
        TotalUtilization: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
    };
};

export const fetchUtilization = async (selected) => {
    const url = "admin/get_bus_utilization_history";
    let formData = new FormData();
    formData.append("period", selected.period);
    formData.append("end_date", selected.date);

    let data = {};
    try {
        const response = await API.postData(url, formData);
        if (!response.status) {
            throw ("Non response history")
        }
        data = {
            DateList: response.data.DateList,
            WeightWaste: response.data.WeightWaste,
            LengthWaste: response.data.LengthWaste,
            WeightUtilization: response.data.WeightUtilization,
            LengthUtilization: response.data.LengthUtilization,
            TotalUtilization: response.data.TotalUtilization,
        };
    }
    catch {
        data = defaultUtilization()
    }
    return data;
};

export const defaultPartials = () => {
    return {
        DateList: [],
        OrdersWithPartials: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
        Partials: { "ALL": [], "CKV": [], "LRD": [], "DTW": [] },
    };
};

export const fetchPartials = async (selected) => {
    const url = "admin/get_bus_partialed_orders";
    let formData = new FormData();
    formData.append("period", selected.period);
    formData.append("end_date", selected.date);

    let data = {};
    try {
        const response = await API.postData(url, formData);
        if (!response.status) {
            throw ("Non response history")
        }
        data = {
            DateList: response.data.DateList,
            OrdersWithPartials: response.data.OrdersWithPartials,
            Partials: response.data.Partials,
        };
    }
    catch {
        data = defaultPartials()
    }
    return data;
};

export const defaultBusHistory = () => {
    return {};
};

export const fetchBusHistory = async (selected) => {
    const url = "admin/get_bus_history";
    let formData = new FormData();
    formData.append("period", selected.period);
    formData.append("end_date", selected.date);

    let data = {};
    try {
        const response = await API.postData(url, formData);
        data = response.data;
        if (!response.status) {
            throw ("Non response history")
        }
    }
    catch {
        data = defaultBusHistory()
    }

    return data;
};

export const defaultSelected = () => {
    const now = new Date()

    const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
    }

    return {
        period: 30,
        date: formatDate(now),
    }
}

export function handleGraphClick(evt, element) {
    // Find the nearest data point
    const activePoints = evt.chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, false);
    if (evt.type === "click" && activePoints.length) {
        var ind = element[0].index;
        var date = evt.chart.config.data.labels[ind];
        var graphTitle = evt.chart.config.options.plugins.title.text;
        const [{ datasetIndex, index }] = activePoints;

        // Declare series and data variables
        const series = evt.chart.data.datasets[datasetIndex].label;
        const data = evt.chart.data.datasets[datasetIndex].data[index];

        if (graphTitle.toLowerCase().includes("all")) {
            var terminal = "all"
        }
        else {
            var terminal = series.slice(0, 3)
        }

        // Log the clicked label and graph title
        // console.log('Clicked label:', date);
        // console.log('Clicked graph:', graphTitle);
        // console.log(`Series: ${series}, Data: ${data}`);

        // Dispatch a custom event with the selected date
        const event = new CustomEvent('dateSelected', { detail: { date, terminal } });
        document.dispatchEvent(event);
    }
}


